import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=55bf8755&"
import script from "./Password.vue?vue&type=script&lang=js&"
export * from "./Password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55bf8755')) {
      api.createRecord('55bf8755', component.options)
    } else {
      api.reload('55bf8755', component.options)
    }
    module.hot.accept("./Password.vue?vue&type=template&id=55bf8755&", function () {
      api.rerender('55bf8755', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Password.vue"
export default component.exports